import React from 'react';
import SectionHeading from './SectionHeading';

const Awards = function({ lang, isDark, sections, awards }) {
  return (
    <section id="awards" className="mb-8" aria-labelledby="awards-heading">
      <div className="section-card">
        <SectionHeading id="awards-heading" isDark={isDark}>{sections.awards}</SectionHeading>
        <div className="space-y-7">
          {awards.map((award, i) => (
            <div key={i} className="flex flex-col gap-2">
              <h3 className={`text-[14px] font-bold leading-snug ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>
                {award.title}
              </h3>
              <p className={`text-[13px] leading-relaxed font-medium ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
                {award.description}
              </p>
              <p className={`text-[11px] font-mono ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>
                {award.year}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default React.memo(Awards);
